import styled, { css } from 'styled-components';
import { Button } from 'style/buttons';

export const SearchButton = styled(Button)<{isHidden?: boolean}>`
    height: 28px;
    padding: 5px;
    font-size: 12px;
    margin: 0 auto;
    ${(props) => props.isHidden && (
        css`
            opacity: 0;
            pointer-events: none;

        `
    )}
`;

export const StartButton = styled(Button)`
    height: 28px;
    padding: 5px;
    font-size: 12px;
    margin-bottom: 10px;
`;

export const RolloverSelectorContainer = styled.div<{readOnly?: boolean}>`
    width: auto;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: 'center';
    justify-content: 'flex-start';
    gap: 20px;
    flex-direction: column;
    pointer-events: ${(props) => props.readOnly ? 'none' : 'auto'};
`;